var TextMessageBuilder = /** @class */ (function () {
    function TextMessageBuilder() {
        this.textMessage = {
            text: '',
            enabled: false,
        };
    }
    TextMessageBuilder.prototype.withText = function (text) {
        this.textMessage.text = text;
        return this;
    };
    TextMessageBuilder.prototype.withEnabled = function (value) {
        this.textMessage.enabled = value;
        return this;
    };
    TextMessageBuilder.prototype.build = function () {
        return this.textMessage;
    };
    return TextMessageBuilder;
}());
export { TextMessageBuilder };
//# sourceMappingURL=text-message.builder.js.map